<script>
import {biller as columns} from '../../tables'

export default {
  data() {
    return {
      columns,
      form: this.$form.createForm(this),
      items: {},
      loading: false,
      expand: false,
      filters: {
        page: 1,
        q: ''
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },

  methods: {
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.pushState(this.filters)
      this.getItems()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        q: null,
        page: 1
      }
    },

    getItems() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.biller'), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-row :gutter="24" class="form-filter-wrapper" :class="expand ? 'expanded' : ''">
        <a-col :span="6">
          <a-input placeholder="Keyword.." v-model="filters.q">
            <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)"/>
          </a-input>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" class="text-right">
          <a-button type="primary" html-type="submit" icon="filter"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Filter
          </a-button>
          <a-button class="ml-2" type="dashed" html-type="reset" icon="reload" @click="handleReset"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Reset
          </a-button>

          <a class="ml-2" @click="() => this.expand = !this.expand ">
            Filter
            <a-icon :type="expand ? 'up' : 'down'"/>
          </a>
        </a-col>
      </a-row>
    </a-form>

    <a-divider dashed/>

    <a-skeleton active :loading="loading">
      <a-table :columns="columns"
               :dataSource="items.data"
               rowKey="hash"
               :pagination="{ current: items.current_page, total: items.total}"
               @change="tableChanged">

        <h4 slot="name" slot-scope="record">
          <a-icon type="idcard" /> <a :href="routeUri('hyperion.biller.driver', { biller_hash: record.hash })">{{ record.contact_name }}</a>
          <br>
          <a-icon type="code" /> <small><code>{{ record.name }}</code></small>
        </h4>

        <h4 slot="contact" slot-scope="record">
          <a-button size="small" type="link" icon="mail" :href="'mailto:' + record.contact_email"/>
          {{ record.contact_email }}
          <br>
          <a-button size="small" type="link" icon="phone" :href="'tel:' + record.contact_phone"/>
          {{ record.contact_phone }}
        </h4>

        <div slot="drivers" slot-scope="drivers">
          <a-tag color="#87d068" v-for="(driver, index) in drivers" :key="`driver-${index}`">{{ driver }}</a-tag>
        </div>

        <h4 slot="balance" slot-scope="balance" :style="{ color: balance >= 0 ? '#237804' : '#a8071a'}">
          {{ currency(balance) }}
        </h4>

        <p slot="updated_at" slot-scope="updated_at" class="text-sm">
          <a-tooltip :title="updated_at">
            {{ moment(updated_at, 'YYYY-MM-DD HH:mm:ss').fromNow() }}
          </a-tooltip>
        </p>

        <div slot="action" class="text-right" slot-scope="record">
          <a-tooltip title="Edit Biller">
            <a-button size="small" type="primary" icon="edit" :href="routeUri('hyperion.biller.edit', { biller_hash: record.hash })"/>
          </a-tooltip>

          <a-tooltip title="Mutation">
            <a-button size="small" icon="fund"
                      :href="routeUri('hyperion.biller.mutation', { biller_hash: record.hash })"/>
          </a-tooltip>

          <a-tooltip title="Transactions">
            <a-button size="small" icon="barcode"
                      :href="routeUri('hyperion.biller.transaction', { biller_hash: record.hash })"/>
          </a-tooltip>

          <a-tooltip title="Attachment">
            <a-button size="small" icon="folder"
                      :href="routeUri('hyperion.biller.attachment', { biller_hash: record.hash })"/>
          </a-tooltip>

          <a-tooltip title="Biller Detail">
            <a-button size="small" icon="ellipsis" :href="routeUri('hyperion.biller.driver', { biller_hash: record.hash })"/>
          </a-tooltip>
        </div>
      </a-table>
    </a-skeleton>
  </a-card>
</template>
